// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Components
import DocumentModeCanvasClusterDebugger from './DocumentModeCanvasClusterDebugger';
import DocumentModeCanvasReadingLineDebugger from './DocumentModeCanvasReadingLineDebugger';

// Styles
import './DocumentModeCanvasDebugger.scss';

const mapStateToProps = (state, ownProps) => ({
    documentModeDebugEnabled: state.getIn(['debug', 'enabled']) && state.getIn(['debug', 'documentMode', 'enabled']),
    documentModeData: state.getIn(['debug', 'documentMode', 'data']),
});

const DocumentModeCanvasDebugger = (props) => {
    const { documentModeDebugEnabled, documentModeData, gridSize } = props;
    if (!documentModeDebugEnabled) return null;

    const clusterReadingLines = documentModeData.getIn(['details', 'readingData']);
    const clustersData = documentModeData.getIn(['details', 'children']);
    const elementOrder = documentModeData.get('order');

    return (
        <div className="DocumentModeCanvasDebugger">
            {clustersData &&
                clustersData.map((clusterData, index) => (
                    <DocumentModeCanvasClusterDebugger
                        key={index}
                        gridSize={gridSize}
                        clusterIndex={index + 1}
                        clusterData={clusterData}
                        elementOrder={elementOrder}
                    />
                ))}
            {clusterReadingLines &&
                clusterReadingLines.map((readingLine, index) => (
                    <DocumentModeCanvasReadingLineDebugger
                        className="cluster"
                        key={index}
                        gridSize={gridSize}
                        order={index + 1}
                        {...readingLine.toJS()}
                    />
                ))}
        </div>
    );
};

DocumentModeCanvasDebugger.propTypes = {
    documentModeDebugEnabled: PropTypes.bool,
    documentModeData: PropTypes.object,
    gridSize: PropTypes.number.isRequired,
};

export default connect(mapStateToProps)(DocumentModeCanvasDebugger);
